import { render } from "./reseted-password.vue?vue&type=template&id=12cf820c&scoped=true&lang=pug"
import script from "./reseted-password.vue?vue&type=script&lang=js"
export * from "./reseted-password.vue?vue&type=script&lang=js"

import "./reseted-password.vue?vue&type=style&index=0&id=12cf820c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12cf820c"]])

export default __exports__